import type { ConversationDotStatus } from "@app/lib/utils/conversation_dot_status";
import { Icon, MessageAlertCircle, cn } from "@dust-tt/sparkle";

export function ConversationSidebarStatusDot({
  status,
  className,
}: {
  status: ConversationDotStatus;
  className?: string;
}) {
  if (status === "idle" || status === "unread") {
    return null;
  }

  return (
    <Icon
      visual={MessageAlertCircle}
      size="xs"
      className={cn("shrink-0 text-muted-foreground", className)}
    />
  );
}
